import { Link } from "react-router-dom";
import { topRanked, formatViews } from "@/mocks/manga";
import SectionHeader from "@/components/common/SectionHeader";

const rankColors = ["bg-primary-500", "bg-accent-500", "bg-secondary-500"];

export default function RankingSection() {
  return (
    <section className="py-10 md:py-14 bg-background-100">
      <div className="mx-auto px-4 md:px-6 max-w-7xl">
        <SectionHeader
          title="91漫画人气榜"
          subtitle="最受读者欢迎的漫画作品，实时更新"
          moreTo="/category/hot"
          icon="ri-fire-fill"
        />
        <div className="grid grid-cols-1 md:grid-cols-2 gap-3 md:gap-4">
          {topRanked.map((m, idx) => (
            <Link
              key={m.id}
              to={`/article/${m.id}`}
              className="flex items-center gap-3 p-3 rounded-lg bg-background-50 border border-background-200/70 hover:border-primary-300 hover:bg-background-50 transition-colors"
            >
              <span
                className={`flex items-center justify-center w-9 h-9 shrink-0 rounded-lg text-background-50 font-heading text-base ${
                  rankColors[idx % rankColors.length]
                }`}
              >
                {idx + 1}
              </span>
              <img
                src={m.cover}
                alt={`${m.title}漫画`}
                title={m.title}
                loading="lazy"
                className="w-12 h-16 shrink-0 rounded-md object-cover object-top"
              />
              <div className="min-w-0 flex-1">
                <h3 className="text-sm font-semibold text-foreground-900 truncate">{m.title}</h3>
                <p className="text-xs text-foreground-600 truncate mt-0.5">{m.categories.join(" · ")}</p>
                <div className="flex items-center gap-3 mt-1 text-xs text-foreground-500">
                  <span className="flex items-center gap-1">
                    <i className="ri-eye-line"></i>
                    {formatViews(m.views)}
                  </span>
                  <span className="flex items-center gap-1 text-accent-600">
                    <i className="ri-star-fill"></i>
                    {m.rating.toFixed(1)}
                  </span>
                </div>
              </div>
              <span
                className={`shrink-0 px-2 py-0.5 rounded-md text-xs ${
                  m.status === "完结"
                    ? "bg-secondary-500 text-background-50"
                    : "bg-primary-100 text-primary-600"
                }`}
              >
                {m.status}
              </span>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}